import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '@platform/state/hooks';
import { selectUi } from '@platform/state/selectors';
import { rightPanelChanged } from '@platform/state/slices/uiSlice';
import { queueAiAsk, rememberAiOpen, restoreAiConversation } from '../aiConversation';

/** Подія «Запитати ШІ» з панелі інструментів запису: detail.text — питання, яке панель має надіслати одразу. */
const ASK_EVENT = 'po:ai-ask';

/**
 * Міст оболонки до ШІ-асистента (прототип v4): відновлює розмову й відкритість панелі користувача після перезавантаження, запам'ятовує,
 * чи панель відкрита, і слухає подію po:ai-ask — відкриває панель і ставить питання в чергу, яку панель надсилає, щойно готова.
 */
export function useAiBridge(userId: string | undefined): boolean {
  const dispatch = useAppDispatch();
  const aiOpen = useAppSelector((s) => selectUi(s).rightPanel === 'ai');
  useEffect(() => {
    if (userId && restoreAiConversation(userId)) dispatch(rightPanelChanged('ai'));
  }, [userId, dispatch]);
  useEffect(() => { if (userId) rememberAiOpen(aiOpen); }, [userId, aiOpen]);
  useEffect(() => {
    const onAsk = (e: Event) => {
      const text = (e as CustomEvent<{ text?: string } | undefined>).detail?.text ?? '';
      dispatch(rightPanelChanged('ai'));
      queueAiAsk(text);
    };
    window.addEventListener(ASK_EVENT, onAsk);
    return () => window.removeEventListener(ASK_EVENT, onAsk);
  }, [dispatch]);
  return aiOpen;
}
